export default "__VITE_ASSET__CQA$CLjP__"